import { type CreateSocialGroup, type GroupMember } from '@app/gen';
export enum GroupPrivacyTypes {
    Public = 'Public',
    Private = 'Private',
}
export type CreateGroupAdminType = CreateSocialGroup['invite_permission'];

export type UpdateGroupMember = Partial<GroupMember>;

export type AdminGroupQuery = {
    query: string;
    page: number;
    limit: number;
    name: string;
};

export type PartialAdminGroupQuery = Partial<AdminGroupQuery>;
